import { FC } from 'react';
import { MyGeneralQuota } from '@/types/assistant';

interface Props {
  quota: MyGeneralQuota | null;
}

function Bar({ label, used, max }: { label: string; used: number; max: number }) {
  const pct = max ? Math.min(100, (used / max) * 100) : 0;
  const danger = pct >= 90;
  return (
    <div className="space-y-1">
      <div className="flex justify-between text-2xs">
        <span className="text-content-tertiary">{label}</span>
        <span className={`font-mono ${danger ? 'text-red-300' : 'text-content-secondary'}`}>
          {used.toLocaleString('pt-BR')}/{max.toLocaleString('pt-BR')}
        </span>
      </div>
      <div className="h-1.5 rounded-full bg-surface-border overflow-hidden">
        <div
          className={`h-full transition-all ${danger ? 'bg-red-400' : 'bg-accent'}`}
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
}

/** Resumo compacto da própria cota do Assistente (G10 — "minha cota"). */
const AssistantQuotaSummary: FC<Props> = ({ quota }) => {
  if (!quota) return null;
  return (
    <div
      data-testid="assistant-quota-summary"
      className="p-4 border-t border-surface-border space-y-3"
    >
      <p className="text-sm font-bold text-content-primary flex items-center gap-2">
        <span className="material-symbols-outlined text-accent text-lg">speed</span>
        Sua cota
      </p>
      <Bar label="Tokens hoje" used={quota.tokens_used_today} max={quota.max_tokens_per_day} />
      <Bar label="Tokens no mês" used={quota.tokens_used_month} max={quota.max_tokens_per_month} />
      <Bar label="Arquivos hoje" used={quota.files_created_today} max={quota.max_files_per_day} />
    </div>
  );
};

export default AssistantQuotaSummary;
